export default "__VITE_ASSET__BBl5bcfc__"